import { Box } from '@chakra-ui/react';

import { TextBold } from 'UiKit/typography';

import styles from './styles.module.css';

const Head = ({ t }) => {
  return (
    <Box className={styles['head__container']}>
      <TextBold className={styles['head__title']}>{t('title')}</TextBold>
    </Box>
  );
};

export default Head;
